$shm_hitalama_process_monitor_detail $mol_page
	key \
	close? null
	title <= method_title \
	tools /
		<= Close $mol_button_minor
			hint \Закрыть
			click? <=> close? null
			sub /
				<= Close_icon $mol_icon_close
	body /
		<= Process $shm_hitalama_process_monitor_detail_process
			key <= key

$shm_hitalama_process_monitor_detail_process $shm_hitalama_process_view
	key \
